import { jsx } from "react/jsx-runtime";
import React from "react";
import { toError } from "../common/error.js";
import InvalidStateError from "./invalid-state-error.js";
import ErrorFallback from "./error-fallback/error-fallback.js";
class ErrorBoundary extends React.Component {
  state = { error: void 0, errorId: void 0 };
  reportToSentry(error) {
    const sentry = new this.props.host.LazySentry({
      dsn: "https://02ede3d0e8514c8eb7de072a1633a404@sentry-next.wixpress.com/15216",
      environment: "Widget",
      beforeSend: (event) => {
        const errorId = event.event_id;
        this.setState({ errorId });
        console.error(`Error id: ${errorId}`);
        return event;
      }
    });
    sentry.configureScope((scope) => {
      if (typeof window !== "undefined") {
        const url = window?.location?.href;
        url && scope.setTag("url", url);
      }
      scope.setTag("isSSR", "false");
      if (!this.props.wfConfig) {
        return;
      }
      const { appName, appVersion, appDefinitionId } = this.props.wfConfig;
      appName && scope.setTag("appName", appName);
      appVersion && scope.setTag("appVersion", appVersion);
      appDefinitionId && scope.setTag("appDefinitionId", appDefinitionId);
    });
    sentry.captureException(error);
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error) {
    try {
      this.reportToSentry(error);
    } catch (exception) {
      console.error(exception);
    }
    try {
      this.props.onError?.(toError(error));
    } catch (exception) {
      console.error(exception);
    }
  }
  render() {
    const { error, errorId } = this.state;
    if (error) {
      return /* @__PURE__ */ jsx(
        ErrorFallback,
        {
          errorMessage: toError(error).message,
          errorId
        }
      );
    }
    if (!this.props.wfConfig) {
      return /* @__PURE__ */ jsx(InvalidStateError, {});
    }
    return this.props.children;
  }
}
export {
  ErrorBoundary as default
};
//# sourceMappingURL=error-boundary.js.map
